// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  height: 100vh;
  --background: transparent;
}

.main-content {
  margin-top: 1rem;
}

.label-style {
  color: var(--color-primary-blue);
}

.image1 {
  position: relative;
  top: -2rem;
  pointer-events: none;
}

.box1 {
  position: absolute;
  top: 0;
  left: 0;
}

.select-box {
  border-radius: 16px;
  box-shadow: rgba(0, 0, 0, 0.16) 2px 3px 0 1px, rgb(209, 213, 219) 0 0 0 1px inset;
  margin-bottom: 1rem;
  margin-top: 0.3rem;
}
.select-box.item-interactive-disabled {
  --background: #D3D3D3;
}

.title-page {
  color: var(--color-primary-blue);
  font-weight: bold;
  font-size: 0.967rem;
  text-align: center;
}

.box2 {
  margin-left: 1rem;
  border: 2px solid var(--color-yellow-box);
  padding: 0.833rem;
  text-align: center;
  font-weight: 900;
  color: var(--color-yellow-box);
  position: relative;
  border-radius: 10px;
  background: #f5db6c linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  box-shadow: rgba(0, 0, 0, 0.16) 2px 3px 0 1px, rgb(209, 213, 219) 0 0 0 1px inset;
}

.sb11:before {
  content: "";
  position: absolute;
  border-left: 2px solid var(--color-yellow-box);
  border-bottom: 2px solid var(--color-yellow-box);
  left: calc(-0.5rem - 2px);
  top: 2.3rem;
  transform: rotateZ(45deg);
  width: 1rem;
  height: 1rem;
  background: #f5db6c;
  border-top: 0;
  border-right: 0;
}

.difficulty-box {
  margin-top: 6.9rem;
  height: max-content;
}

.buttons-main-style {
  margin-left: 2rem;
}

.back-btn {
  width: 2.688rem;
  height: 2.667rem;
  cursor: pointer;
}

.text-topic {
  color: #564547;
  font-size: 0.9rem;
}

.text-disclaimer {
  color: #564547;
  font-size: 0.9rem;
  font-style: italic;
}

.title-row-margin {
  margin-top: 2.583rem;
}

.newGameForm ion-select > label,
.newGameForm ion-select,
.newGameForm ion-item {
  --min-height: 2.667rem;
  min-height: 2.667rem;
  color: var(--color-primary-blue);
  --border-radius: 16px;
}
.newGameForm ion-select {
  --padding-start: 0;
  --padding-bottom: 0;
  --padding-top: 0;
  font-size: 1rem;
  font-weight: 600;
}
.newGameForm .select-text {
  white-space: normal !important;
}

.popover-content {
  --min-width: 100%;
}

.width100 {
  width: 100%;
}

.customise-btn {
  font-size: 1rem;
  min-width: 6.333rem;
  height: 1.667rem;
  min-height: 1.667rem;
  --min-height: 1.667rem;
  margin-top: 1.5rem;
  margin-right: 2.1rem;
  font-weight: 600;
}

.start-btn {
  min-width: 14rem;
  height: 2.667rem;
  --min-height: 2.667rem;
  min-height: 2.667rem;
  font-size: 1.167rem;
  margin-top: 2rem;
  font-weight: 600;
}

.last-row {
  margin-top: 2.5rem;
}

.avatar-div {
  display: flex;
  justify-content: center;
  position: relative;
}
.avatar-div .avatar-svg {
  width: 6rem;
  margin-left: 1.1rem;
  margin-top: 1.6rem;
  z-index: 5;
}
.avatar-div .glow {
  position: relative;
  width: 6rem;
  left: -4.8rem;
  margin-left: -3.7rem;
  margin-top: 8rem;
}
.avatar-div .platform-glow {
  position: relative;
  top: -1.026rem;
  left: 1.15rem;
  height: 4.036rem;
  width: 7.458rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.4) 100%);
}
.avatar-div .triangle {
  position: absolute;
  top: 3.01rem;
  left: 1.1rem;
  border: 3.8rem solid transparent;
  border-top: 1.9rem solid rgba(255, 255, 255, 0.4);
}
.avatar-div .platform-glow-copy {
  position: absolute;
  top: 0.5rem;
  left: 2.5rem;
  height: 2.458rem;
  width: 4.855rem;
  background: linear-gradient(180deg, rgba(249, 236, 177, 0) 0%, rgba(255, 255, 255, 0.55) 100%);
}
.avatar-div .triangle-copy {
  position: absolute;
  top: 2.96rem;
  left: 2.4rem;
  border: 2.5rem solid transparent;
  border-top: 1.3rem solid rgba(255, 255, 255, 0.55);
}

.multiplayer-avatar-col {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.multiplayer-avatar-col .avatar-div {
  display: flex;
  justify-content: center;
}
.multiplayer-avatar-col .avatar-div .avatar-multiplayer {
  width: 5.125rem;
  height: 9.625rem;
}

.margin-top-2 {
  margin-top: 2.667rem;
}`, "",{"version":3,"sources":["webpack://./src/app/game/single-player-menu/single-player-menu.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AACA;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AAGF;;AAAA;EACE,mBAAA;EACA,iFAAA;EAEA,mBAAA;EACA,kBAAA;AAEF;AAAE;EACE,qBAAA;AAEJ;;AAEA;EACE,gCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,yCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,sGAAA;EAMA,iFAAA;AAJF;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,8CAAA;EACA,gDAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AALF;;AAQA;EACE,kBAAA;EACA,mBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AALF;;AAQA;EACE,cAAA;EACA,iBAAA;AALF;;AAQA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AASE;;;EAGE,sBAAA;EACA,oBAAA;EACA,gCAAA;EACA,qBAAA;AANJ;AASE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAPJ;AAUE;EACE,8BAAA;AARJ;;AAYA;EACE,iBAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AATF;;AAYA;EACE,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AATF;;AAYA;EACE,kBAAA;AATF;;AAYA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AATF;AAWE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AATJ;AAYE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;AAVJ;AAaE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,2HAAA;AAXJ;AAmBE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;EACA,iDAAA;AAjBJ;AAoBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,8FAAA;AAlBJ;AAyBE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;EACA,kDAAA;AAvBJ;;AA2BA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;AAxBF;AA0BE;EACE,aAAA;EACA,uBAAA;AAxBJ;AA0BI;EACE,eAAA;EACA,gBAAA;AAxBN;;AA6BA;EACE,oBAAA;AA1BF","sourcesContent":["ion-content {\n  height: 100vh;\n  --background: transparent;\n}\n\n.main-content {\n  margin-top: 1rem;\n}\n\n.label-style {\n  color: var(--color-primary-blue);\n}\n.image1 {\n  position: relative;\n  top: -2rem;\n  pointer-events: none;\n}\n.box1 {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.select-box {\n  border-radius: 16px;\n  box-shadow: rgba(0, 0, 0, 16%) 2px 3px 0 1px,\n    rgb(209, 213, 219) 0 0 0 1px inset;\n  margin-bottom: 1rem;\n  margin-top: 0.3rem;\n\n  &.item-interactive-disabled {\n    --background: #D3D3D3;\n  }\n}\n\n.title-page {\n  color: var(--color-primary-blue);\n  font-weight: bold;\n  font-size: 0.967rem;\n  text-align: center;\n}\n\n.box2 {\n  margin-left: 1rem;\n  border: 2px solid var(--color-yellow-box);\n  padding: 0.833rem;\n  text-align: center;\n  font-weight: 900;\n  color: var(--color-yellow-box);\n  position: relative;\n  border-radius: 10px;\n  background: #f5db6c\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.48) 100%\n    );\n  box-shadow: rgba(0, 0, 0, 16%) 2px 3px 0 1px,\n    rgb(209, 213, 219) 0 0 0 1px inset;\n}\n\n.sb11:before {\n  content: \"\";\n  position: absolute;\n  border-left: 2px solid var(--color-yellow-box);\n  border-bottom: 2px solid var(--color-yellow-box);\n  left: calc(-0.5rem - 2px);\n  top: 2.3rem;\n  transform: rotateZ(45deg);\n  width: 1rem;\n  height: 1rem;\n  background: #f5db6c;\n  border-top: 0;\n  border-right: 0;\n}\n\n.difficulty-box {\n  margin-top: 6.9rem;\n  height: max-content;\n}\n\n.buttons-main-style {\n  margin-left: 2rem;\n}\n\n.back-btn {\n  width: 2.688rem;\n  height: 2.667rem;\n  cursor: pointer;\n}\n\n.text-topic {\n  color: #564547;\n  font-size: 0.9rem;\n}\n\n.text-disclaimer {\n  color: #564547;\n  font-size: 0.9rem;\n  font-style: italic;\n}\n\n.title-row-margin {\n  margin-top: 2.583rem;\n}\n\n.newGameForm {\n  ion-select > label,\n  ion-select,\n  ion-item {\n    --min-height: 2.667rem;\n    min-height: 2.667rem;\n    color: var(--color-primary-blue);\n    --border-radius: 16px;\n  }\n\n  ion-select {\n    --padding-start: 0;\n    --padding-bottom: 0;\n    --padding-top: 0;\n    font-size: 1rem;\n    font-weight: 600;\n  }\n\n  .select-text {\n    white-space: normal !important;\n  }\n}\n\n.popover-content {\n  --min-width: 100%;\n}\n\n.width100 {\n  width: 100%;\n}\n\n.customise-btn {\n  font-size: 1rem;\n  min-width: 6.333rem;\n  height: 1.667rem;\n  min-height: 1.667rem;\n  --min-height: 1.667rem;\n  margin-top: 1.5rem;\n  margin-right: 2.1rem;\n  font-weight: 600;\n}\n\n.start-btn {\n  min-width: 14rem;\n  height: 2.667rem;\n  --min-height: 2.667rem;\n  min-height: 2.667rem;\n  font-size: 1.167rem;\n  margin-top: 2rem;\n  font-weight: 600;\n}\n\n.last-row {\n  margin-top: 2.5rem;\n}\n\n.avatar-div {\n  display: flex;\n  justify-content: center;\n  position: relative;\n\n  .avatar-svg {\n    width: 6rem;\n    margin-left: 1.1rem;\n    margin-top: 1.6rem;\n    z-index: 5;\n  }\n\n  .glow {\n    position: relative;\n    width: 6rem;\n    left: -4.8rem;\n    margin-left: -3.7rem;\n    margin-top: 8rem;\n  }\n\n  .platform-glow {\n    position: relative;\n    top: -1.026rem;\n    left: 1.15rem;\n    height: 4.036rem;\n    width: 7.458rem;\n    background: linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.2) 50%,\n      rgba(255, 255, 255, 0.4) 100%\n    );\n  }\n\n  .triangle {\n    position: absolute;\n    top: 3.01rem;\n    left: 1.1rem;\n    border: 3.8rem solid transparent;\n    border-top: 1.9rem solid rgba(255, 255, 255, 0.4);\n  }\n\n  .platform-glow-copy {\n    position: absolute;\n    top: 0.5rem;\n    left: 2.5rem;\n    height: 2.458rem;\n    width: 4.855rem;\n    background: linear-gradient(\n      180deg,\n      rgba(249, 236, 177, 0) 0%,\n      rgba(255, 255, 255, 0.55) 100%\n    );\n  }\n\n  .triangle-copy {\n    position: absolute;\n    top: 2.96rem;\n    left: 2.4rem;\n    border: 2.5rem solid transparent;\n    border-top: 1.3rem solid rgba(255, 255, 255, 0.55);\n  }\n}\n\n.multiplayer-avatar-col {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n\n  .avatar-div {\n    display: flex;\n    justify-content: center;\n\n    .avatar-multiplayer {\n      width: 5.125rem;\n      height: 9.625rem;\n    }\n  }\n}\n\n.margin-top-2 {\n  margin-top: 2.667rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
